// 担保人邮箱转发状态：小徽章 + 任务详情里那一行（一个担保人担保几个人，共用一个状态）
import { Link } from "react-router-dom";
import type { SponsorMailStatus, TaskDTO } from "@csp/shared";
import { api } from "../lib/api";
import { fmtDateTime, fmtTime } from "../lib/format";
import { useLoad } from "../lib/hooks";
import { Badge } from "./Badges";

const TEXT: Record<SponsorMailStatus, string> = { ok: "已转发", failed: "转发失败", unknown: "未验证" };
const TONE = { ok: "green", failed: "red", unknown: "gray" } as const;

export function SponsorMailBadge({ status }: { status: SponsorMailStatus }) {
  return <Badge tone={TONE[status]}>{status === "ok" ? "✓ " : status === "failed" ? "✕ " : ""}{TEXT[status]}</Badge>;
}

/** 任务材料里的担保人邮箱（材料提取字段 sponsorEmail） */
export function sponsorEmailOf(task: TaskDTO): string | null {
  const fields = (task.extraction as { fields?: { key: string; value?: unknown }[] } | null)?.fields ?? [];
  const v = fields.find((f) => f.key === "sponsorEmail")?.value;
  return typeof v === "string" && v.includes("@") ? v.trim().toLowerCase() : null;
}

/** 任务详情：担保人邮箱 + 转发状态 */
export function SponsorMailLine({ email }: { email: string }) {
  const q = useLoad(() => api.sponsorMails(), [email]);
  const s = q.data?.find((x) => x.email === email);
  return (
    <div className="meta" data-testid="sponsor-mail">
      担保人邮箱 <span translate="no">{email}</span> 转发到 ss@kaider.sg：{s ? <SponsorMailBadge status={s.status} /> : <SponsorMailBadge status="unknown" />}
      {s?.lastMailAt && <span className="muted" title={fmtDateTime(s.lastMailAt)}> 最近收到 ICA 来信 {fmtTime(s.lastMailAt)}</span>}
      {" · "}<Link to="/sponsor-mails">全部担保人</Link>
    </div>
  );
}
